import { Box, type BoxProps } from '@mui/material'

import { color } from '@/v2/design-system/tokens'

/** Superficie para franjas de comando/acción (Ask GOVIA, CommandInput) — el
 * único lugar de la V2 que usa el degradado de marca (`gradientSubtle`),
 * para que destaque como el punto de entrada a GOVIA AI sin ser un color
 * decorativo suelto. */
export function CommandSurface({ sx, ...props }: BoxProps) {
  return (
    <Box
      sx={{
        borderRadius: 3,
        border: `1px solid ${color.border}`,
        backgroundImage: color.gradientSubtle,
        backgroundColor: color.surface,
        px: { xs: 2.5, md: 4 },
        py: { xs: 3, md: 3.5 },
        ...sx,
      }}
      {...props}
    />
  )
}
